<template>
  <div class="right-container">

    <ChangePasswordDialog ref="ChangePasswordDialog"/>

    <img class="bell-img" src="@/assets/images/notification.png" style="cursor: pointer" alt=""/>

    <el-popover popper-class="user-popover" placement="top-start" width="300" trigger="hover">
      <template>
        <div class="user-info-container">
          <div>
            <span>accessKeyId:</span>
            <span> {{ user['accessKey'] }}</span>
          </div>
          <div class="mg-t-5">
            <span>accessKeySecret:</span>
            <!-- <span> {{ user['accessSecret'] }}</span> -->
            <span>******</span>
          </div>
        </div>

        <div class="user-info-container copyBox">
          <el-button type="text" style="padding-bottom: 0; padding-top: 5px" @click="cotyTextAll">一键复制</el-button>
        </div>

        <div class="user-info-container account">
          <div class="account-info-item">
            <div class="label">UserId</div>
            <div class="value">{{ user['userId'] }}</div>
          </div>
        </div>

        <div class="button-container user-info-container">
          <button @click="onClickChangePasswordBtn" class="user-btn">修改密码</button>
          <button @click="logout" class="user-btn">退出登录</button>
        </div>
      </template>

      <div class="avatar-and-account" slot="reference">
        <img class="user-avatar" src="@/assets/images/profile.jpg" alt=""/>
        <div class="user-account">{{ user.account }}</div>
      </div>
    </el-popover>

    <img class="logout-btn" @click="logout" src="@/assets/images/logout.png" alt=""/>
  </div>
</template>

<script>
import {removeToken} from '@/utils/auth';
import {ApiGetUserInfo} from "@/api/loginUser/loginUser";
import ChangePasswordDialog from "@/componentsNew/user/ChangePasswordDialog/ChangePasswordDialog.vue";

export default {
  components: {ChangePasswordDialog},
  data(){
    return {
      user: {}
    }
  },

  mounted(){
    this.getUserInfo()
  },
  methods: {
    onClickChangePasswordBtn(){
      this.$refs['ChangePasswordDialog'].start();
    },
    copyTextInPage(value){
      this.copyText(value);
    },
    getUserInfo(){
      let data = {}
      ApiGetUserInfo(data).then(res => {
        this.user = res?.data || {}
      })
    },
    // 复制全部
    cotyTextAll(){
      let obj = {
        accessKeyId: this.user.accessKey,
        accessKeySecret: this.user['accessSecret'],
      };
      let text = JSON.stringify(obj);
      this.copyTextInPage(text)
    },

    async logout(){
      this.$confirm('确定注销并退出系统吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$router.replace({path: '/login'}); // 使用路由跳转
          history.replaceState({}, '', window.location.href);
          removeToken();
        })
        .catch(() => {
        });
    },
  },
};
</script>

<style lang="scss">
.user-popover {
  padding: 12px 0;

  .user-info-container {
    padding-left: 12px;
    padding-right: 12px;
  }

  .account {
    border-top: 1px solid #eeeeee;
    border-bottom: 1px solid #eeeeee;
    padding-top: 12px;
    padding-bottom: 12px;

    .account-info-item {
      display: flex;
      align-items: center;
      line-height: 20px;

      &:nth-child(1) {
        margin-bottom: 8px;
      }

      .label {
        font-size: 14px;
        color: #cccccc;
        width: 68px;
      }

      .value {
        color: #333333;
        font-size: 14px;
      }

      .copyIcon {
        margin-left: 12px;
        cursor: pointer;

        .icon {
          font-size: 16px;
        }
      }
    }
  }

  .button-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 20px;
    padding-bottom: 8px;

    .user-btn {
      cursor: pointer;
      width: calc((100% - 12px) / 2);
      height: 38px;
      background: #fcfcfc;
      border-radius: 2px;
      border: 1px solid #eeeeee;
      font-size: 14px;
      color: #333333;

      &:hover {
        background: #ff6a00;
        border: 1px solid #ff6a00;
        color: #ffffff;
      }
    }
  }

  .copyBox {
    display: flex;
    justify-content: flex-end;
  }
}
</style>

<style lang="scss" scoped>
.right-container {
  cursor: pointer;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;

  .bell-img {
    width: 18px;
    height: 18px;
    margin-right: 20px;
  }

  .avatar-and-account {
    display: flex;
    justify-content: center;
    align-items: center;

    .user-avatar {
      cursor: pointer;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 10px;
    }

    .user-account{
      font-size: 14px;
    }

  }

  .logout-btn {
    cursor: pointer;
    width: 16px;
    height: 16px;
    margin: 0 20px;
  }

}
</style>
